export const tradeRequestsGetters = {
  allTradeRequests: (state) => state.allTradeRequests,
  tradeRequestFormStatus: (state) => state.tradeRequestFormStatus,
  tradeRequestIsEdit: state => state.tradeRequestIsEdit,
  tradeRequestSelectedForEdit: state => state.tradeRequestSelectedForEdit,
  tradeRequestShowDetailForm :state =>state.tradeRequestShowDetailForm,
  tradeRequestSingleItem : state =>state.tradeRequestSingleItem,
  tradeRequestItems : state =>state.tradeRequestItems,
  tradeRequestSingleItemForEdit: state =>state.tradeRequestSingleItemForEdit,
  tradeRequestSelectedForDisplay :state =>state.tradeRequestSelectedForDisplay,
  tradeRequestCategoryType:state =>state.tradeRequestCategoryType,
  tradeRequestEditMode:state =>state.tradeRequestEditMode, //edit a single Item
  tradeRequestItemEditMode:state =>state.tradeRequestItemEditMode,
  tradeRequestResponsesPerItem: state => state.tradeRequestResponsesPerItem,
  tradeRequestNumber :state =>state.tradeRequestNumber,
  tradeRequestDate :state =>state.tradeRequestDate,
  tradeRequestResponsesHeader :state =>state.tradeRequestResponsesHeader,
  tradeRequestSelectedForResponse:state =>state.tradeRequestSelectedForResponse,
  tradeRequestPageNumber : state =>state.tradeRequestPageNumber,
  tradeRequestItemsPerPage :state =>state.tradeRequestItemsPerPage,
  tradeRequestSelectedItem : state =>state.tradeRequestSelectedItem,
  tradeRequestCurrentList: state => state.tradeRequestCurrentList,
   tradeRequestDirectCurrentList : state =>state.tradeRequestDirectCurrentList,
  tradeRequestSelectedToFinalize: state => state.tradeRequestSelectedToFinalize,
  directOrderListPageNumber: state => state.directOrderListPageNumber,
  directOrderListItemsPerPage: state => state.directOrderListItemsPerPage,
};
